"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-mjf-multi-jet-fusion";

const HERO_IMAGE = "/image/new-version/more/MJF/efficient-practical-advantages-of-mjf-3d-printing.webp";

const ITEMS = [
	{ titleKey: "advantagesItem1Title", descKey: "advantagesItem1Desc" },
	{ titleKey: "advantagesItem2Title", descKey: "advantagesItem2Desc" },
	{ titleKey: "advantagesItem3Title", descKey: "advantagesItem3Desc" },
	{ titleKey: "advantagesItem4Title", descKey: "advantagesItem4Desc" },
	{ titleKey: "advantagesItem5Title", descKey: "advantagesItem5Desc" },
] as const;

function CheckIcon() {
	return (
		<div
			className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-themePrimary400 sm:h-6 sm:w-6"
			aria-hidden
		>
			<svg className="h-3 w-3 text-white sm:h-3.5 sm:w-3.5" viewBox="0 0 12 10" fill="none" aria-hidden>
				<path
					d="M1 5l3.5 3.5L11 1"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
}

export default function MjfAdvantages() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
					<span className="mb-3 inline-block text-xl uppercase tracking-wider text-themePrimary400 max-md:text-lg">
						{t("advantagesEyebrow")}
					</span>
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("advantagesTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("advantagesDesc")}</p>
				</div>

				<div className="flex flex-col gap-8 lg:flex-row lg:items-stretch lg:gap-12 xl:gap-16">
					<div className="relative w-full overflow-hidden lg:min-h-0 lg:w-1/2">
						<div className="relative aspect-[4/3] w-full lg:absolute lg:inset-0 lg:aspect-auto">
							<Image
								src={HERO_IMAGE}
								alt={t("advantagesImageAlt")}
								fill
								className="object-cover"
								sizes="(max-width: 1024px) 100vw, 50vw"
							/>
						</div>
					</div>

					<div className="flex min-w-0 flex-col justify-center lg:w-1/2">
						<ul className="space-y-6 sm:space-y-7">
							{ITEMS.map((item) => (
								<li key={item.titleKey} className="flex gap-3 sm:gap-4">
									<CheckIcon />
									<div>
										<p className="mb-1 text-base font-semibold text-black sm:text-lg">{t(item.titleKey)}</p>
										<p className="text-sm leading-relaxed text-black md:text-base">{t(item.descKey)}</p>
									</div>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
}
